module.exports = __webpack_public_path__ + "img/烟花1.3b859d88.gif";